<div id="layout-config" class="layout-config " [ngClass]="{'layout-config-active': appMain.configActive}"
    (click)="appMain.onConfigClick($event)">
    <a id="gridConfigButton" class="layout-config-button" href="javascript:;" pTooltip="Additional Options"
        *ngIf="!(router?.url?.includes('docstatus-management') || router?.url?.includes('billing-details') || router?.url?.includes('announcement') || router?.url?.includes('bre'))"
        tooltipPosition="left" class="layout-config-button fab-button" (click)="onConfigButtonClick($event)">
        <i class="pi pi-ellipsis-v fab-button-icon ellip"></i>
    </a>
    <div class="layout-config-content">
        <p-panelMenu [model]="items" styleClass="w-100 mt-5"></p-panelMenu>
    </div>
</div>
<div class="table-anim" [ngClass]="isTableExpanded?'expand-table':''">
    <p-table #dt [value]="data" dataKey="id" [scrollable]="true" class="test-data" styleClass="p-datatable-sm"
        selectionMode="single" [showCurrentPageReport]="true" [paginator]="false" [columns]="user_grid_schema"
        [lazy]="true" (onLazyLoad)="sortColumn($event)" [sortField]="default_order_by"
        [sortOrder]="order_type" [responsive]="true">
        <ng-template pTemplate="caption">
            <div class="table-header"
                style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">

                <!-- Left section: Duration, Date Range, Reset (Billing only) -->
                <div style="display: flex; align-items: center; flex-wrap: wrap;">
                    <span class="mr-3" *ngIf="name == 'billing'">
                        <p-dropdown [options]="reportType" [(ngModel)]="selectedReportType" optionLabel="name"
                            placeholder="Select Duration" styleClass="w-12" (onChange)="fetchDurationList()"
                            [disabled]="rangeDates && rangeDates.length > 0" />
                    </span>

                    <span class="mr-3" *ngIf="name == 'billing'">
                        <p-calendar [(ngModel)]="rangeDates" selectionMode="range" dateFormat="yy-mm-dd"
                            tooltipPosition="left" [hideOnDateTimeSelect]="true" [showIcon]="true" showClear="true"
                            showButtonBar="true" [readonlyInput]="true" (click)="fetchDateRange()" [maxDate]="maxDate"
                            [disabled]="selectedReportType" placeholder="Select Date Range" />
                    </span>

                    <span class="mr-3" *ngIf="name == 'billing'">
                        <button (click)="onClickReset()" pButton class="text-button link-button"
                            icon="pi pi-filter-slash" pTooltip="RESET">
                        </button>
                    </span>
                    <!-- <span class="p-input-icon-left mr-3" *ngIf="name == 'billing'">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search" />
                </span> -->
                </div>

                <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 0.5rem;">
                    <!-- <span class="p-input-icon-left mr-3" *ngIf="router?.url?.includes('search/document-grid')">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"  (input)="dt.filterGlobal($event.target.value, 'contains')"
                            placeholder="Search" />
                    </span>  -->
                    <!-- <button *ngIf="router?.url?.includes('search/document-grid')" id="filterButton" aria-label="Filter Data" href="javascript:;" pTooltip="Filter" tooltipPosition="top"
                        (click)="toggleTableFilter()"  [ngClass]="['grid-buttons', handleFilter === true ? 'active' : '']" pButton
                        >
                        <img src="../../../../../assets/layout/images/filter.svg" *ngIf="!handleFilter">
                        <img src="../../../../../assets/layout/images/filter-invert.svg" *ngIf="handleFilter">
                    </button> -->
                    <!-- Export Excel -->
                    <!-- <button (click)="onClickExportExcel()" *ngIf="!router?.url?.includes('user/admin/docstatus-management')" class="mr-2" pButton tooltipPosition="top"
                        pTooltip="Export Excel" class="grid-buttons">
                        <img src="../../../../../assets/layout/images/export_excel.svg">
                    </button> -->
                    <!-- Column Settings -->
                    <!-- edited -->
                    <!-- <button *ngIf="router?.url?.includes('search/document-grid')" (click)="onClickShowColumnSettingsModal()"
                        class="mr-2" pButton tooltipPosition="top" pTooltip="Column Settings" icon="fad fa-line-columns"
                        style="cursor: pointer; color: #1b5786 !important; background-color: #fff;">
                    </button>  -->




                    <!-- Upload Document -->
                    <!-- <button (click)="onClickUploadInvoice()" *ngIf="router?.url?.includes('search/document-grid')" class="mr-2" pButton tooltipPosition="top"
                        pTooltip="Upload Document" class="grid-buttons">
                        <img src="../../../../../assets/layout/images/upload_excel.svg" class="mr-3"> <span style="color:#1E5AA8 ;">Upload Document</span>
                    </button> -->

                    <div class="toolbar-actions flex align-items-center gap-2 flex-nowrap">
                        <!-- <span class="p-input-icon-left mr-3" *ngIf="router?.url?.includes('search/document-grid')">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="Search"  />
                        </span> -->
                        <div class="flex align-items-center gap-2"
                            *ngIf="router?.url?.includes('search/document-grid') && [30,45,50,70].includes(selectedCard.id)">
                            <p-inputSwitch [(ngModel)]="isAssigned" class="small-switch"
                                (onChange)="assignedInvoices()"></p-inputSwitch>

                            <span class="">Assigned Invoices</span>

                        </div>
                        <p-multiSelect *ngIf="router?.url?.includes('search/document-grid')" [options]="selectedColumns"
                            [(ngModel)]="tableHeader" optionLabel="label" pTooltip="Column Settings"
                            tooltipPosition="top" [style]="{ width: '13em','display':'flex','align-items':'center' }"
                            optionDisabled="isDisabled" defaultLabel="Column Settings"
                            selectedItemsLabel="Select Column Settings" [maxSelectedLabels]="0"  [filterBy]="'label'" [filter]="true"       
                            [selectedItemsLabel]="'{0} items selected'" [showToggleAll]="false"
                            (onSelectAllChange)="selectedColumns()" (onChange)="validateSelection($event)">
                         
                            <ng-template let-option pTemplate="item">
                                {{ option.label }}
                            </ng-template>
                        </p-multiSelect>

                        <!-- Sidebar filter -->
                        <ng-container *ngIf="buttonConfig?.hideFilterButton && grid_schema?.length > 0">
                            <app-sidebar-filter (clearFilterModel)="clearFilterModel()"
                                (populateFilter)="populateFilterTemplateData($event)" [module_id]="module_id"
                                [documentFieldList]="documentFieldList"
                                [showFilterTemplate]="isSuperuser || buttonConfig?.showFilterTemplate"
                                [showSaveFilterTemplate]="isSuperuser || buttonConfig?.showFilterTemplateCreate"
                                [showDeleteTemplate]="isSuperuser || buttonConfig?.showDeleteTemplate"
                                [grid_schema]="grid_schema" [showFilter]="showFilter"
                                (applyFilter)="onClickFilter($event)" (resetFilter)="onClickReset()"
                                (toggleFilter)="showFilter = !showFilter" [filterModel]="filterModel"
                                (dateSelectFilter)="onDateSelect($event)" (closeSidebar)="closeSidebar()">
                            </app-sidebar-filter>
                            <!-- <button class="mr-2" style="cursor: pointer;color: #1b5786 !important;background-color: #fff;" pButton>
                            <a class="p-overlay-badge topbar-icon ml-2" (click)="sendRefreshClickEvent()" tooltipPosition="top"
                                href="javascript:;" pTooltip="Refresh (Ctrl+R)" aria-label="Refresh the Current Page">
                                <i class="fas fa-sync-alt" [@rotatedState]='rotateState'></i>
                            </a>
                        </button> -->
                        </ng-container>

                        <!-- Select Columns -->
                        <!-- <p-multiSelect 
                        [options]="selectedColumns"
                        [(ngModel)]="tableHeader"
                        (onSelectAllChange)="onSelectAllChangeMultiselect($event)"
                        
                        optionLabel="label"
                        optionValue="key"
                        optionDisabled="isDisabled"
                        placeholder="Select Columns"
                        class="w-12rem"  *ngIf="router?.url?.includes('search/document-grid')">
                        <ng-template pTemplate="footer">
                            <span class="flex justify-content-center p-2">
                                <button pButton label="APPLY"
                                    class="sidebar-button cozmos-primary-button"
                                    (click)="onClickApplyOptionsFilter(multiselect)"></button>
                                <button pButton label="CLEAR"
                                    class="sidebar-button cozmos-secondary-button ml-2"
                                    (click)="onClickClearOptionsFilter(multiselect,col?.key)"></button>
                            </span>
                        </ng-template>
                        </p-multiSelect> -->

                        <!-- table Filter -->
                        <!-- <button *ngIf="router?.url?.includes('search/document-grid')"
                            id="filterButton"
                            aria-label="Filter Data"
                            href="javascript:;"
                            class="mr-2"
                            pTooltip="Filter"
                            tooltipPosition="top"
                            (click)="toggleTableFilter()"
                            [ngClass]="['grid-buttons', handleFilter ? 'active' : '']"
                            pButton>
                            <img src="../../../../../assets/layout/images/filter.svg" *ngIf="!handleFilter">
                            <img src="../../../../../assets/layout/images/filter-invert.svg" *ngIf="handleFilter">
                        </button> -->

                        <!-- Export -->
                        <button (click)="onClickExportExcel()"
                            *ngIf="!router?.url?.includes('user/admin/docstatus-management')" class="grid-buttons"
                            pButton tooltipPosition="top" pTooltip="Export Excel">
                            <svg width="18" height="23" viewBox="0 0 18 23" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.175 18.875L10.825 16.525C10.6417 16.3417 10.55 16.1292 10.55 15.8875C10.55 15.6459 10.6417 15.4334 10.825 15.25C11.0084 15.0667 11.2209 14.975 11.4625 14.975C11.7042 14.975 11.9167 15.0667 12.1 15.25L12.9 16.05V13.1983C12.9 12.9438 12.9858 12.7304 13.1573 12.5583C13.3288 12.3861 13.5413 12.3 13.7948 12.3C14.0483 12.3 14.2625 12.3861 14.4375 12.5583C14.6125 12.7304 14.7 12.9438 14.7 13.1983V16.05L15.475 15.275C15.6584 15.0917 15.8709 15 16.1125 15C16.3542 15 16.5667 15.0917 16.75 15.275C16.9334 15.4584 17.0292 15.6667 17.0375 15.9C17.0459 16.1334 16.9584 16.3417 16.775 16.525L14.4215 18.8785C14.2405 19.0595 14.0319 19.15 13.7955 19.15C13.5592 19.15 13.3524 19.0584 13.175 18.875ZM11.107 22.5C10.8524 22.5 10.6375 22.4143 10.4625 22.2428C10.2875 22.0713 10.2 21.8588 10.2 21.6053C10.2 21.3518 10.2862 21.1375 10.4585 20.9625C10.6309 20.7875 10.8444 20.7 11.099 20.7H16.493C16.7477 20.7 16.9625 20.7858 17.1375 20.9573C17.3125 21.1288 17.4 21.3413 17.4 21.5948C17.4 21.8483 17.3139 22.0625 17.1415 22.2375C16.9692 22.4125 16.7557 22.5 16.501 22.5H11.107ZM2.10005 18.9C1.61672 18.9 1.19588 18.7209 0.837549 18.3625C0.479216 18.0042 0.300049 17.5834 0.300049 17.1V2.70002C0.300049 2.21669 0.479216 1.79586 0.837549 1.43752C1.19588 1.07919 1.61672 0.900024 2.10005 0.900024H9.15005C9.38338 0.900024 9.61255 0.941691 9.83755 1.02502C10.0625 1.10836 10.2584 1.24169 10.425 1.42502L14.175 5.17502C14.3584 5.34169 14.4917 5.53752 14.575 5.76252C14.6584 5.98752 14.7 6.21669 14.7 6.45002V9.60002C14.7 9.85502 14.6138 10.0688 14.4413 10.2413C14.2688 10.4138 14.055 10.5 13.8 10.5H10.5C10.005 10.5 9.5813 10.6763 9.2288 11.0288C8.8763 11.3813 8.70005 11.805 8.70005 12.3V18C8.70005 18.255 8.6138 18.4688 8.4413 18.6413C8.2688 18.8138 8.05505 18.9 7.80005 18.9H2.10005ZM10.05 6.90002H12.9L8.70005 2.70002V5.55002C8.70005 5.92502 8.8313 6.24377 9.0938 6.50627C9.3563 6.76877 9.67505 6.90002 10.05 6.90002Z"
                                    fill="#1E5AA8" />
                            </svg>
                        </button>

                        <!-- Upload Document -->
                        <button (click)="onClickUploadInvoice()"
                            *ngIf="router?.url?.includes('search/document-grid') && selectedCard.id == 5" pButton
                            tooltipPosition="top" pTooltip="Upload Invoice" class="grid-buttons" size="small">
                            <svg width="15" height="21" viewBox="0 0 15 21" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.60005 12.75V15.6018C6.60005 15.8563 6.6858 16.0696 6.8573 16.2418C7.0288 16.4139 7.2413 16.5 7.4948 16.5C7.7483 16.5 7.96255 16.4139 8.13755 16.2418C8.31255 16.0696 8.40005 15.8563 8.40005 15.6018V12.75L9.1928 13.5428C9.28097 13.6309 9.38338 13.6959 9.50005 13.7375C9.61671 13.7792 9.72921 13.8 9.83755 13.8C9.94588 13.8 10.0584 13.7792 10.175 13.7375C10.2917 13.6959 10.3917 13.6334 10.475 13.55C10.6584 13.3667 10.75 13.1542 10.75 12.9125C10.75 12.6709 10.6595 12.4595 10.4785 12.2785L8.12505 9.92502C8.04005 9.83419 7.94797 9.76977 7.8488 9.73177C7.74963 9.69394 7.63338 9.67502 7.50005 9.67502C7.36671 9.67502 7.25046 9.69394 7.1513 9.73177C7.05213 9.76977 6.96005 9.83419 6.87505 9.92502L4.52155 12.2785C4.34055 12.4595 4.25388 12.6682 4.26155 12.9045C4.26922 13.1409 4.36538 13.3477 4.55005 13.525C4.73338 13.7084 4.94588 13.8 5.18755 13.8C5.42922 13.8 5.63938 13.7107 5.81805 13.532L6.60005 12.75ZM2.09305 20.1C1.59772 20.1 1.17505 19.9238 0.825049 19.5713C0.475049 19.2188 0.300049 18.795 0.300049 18.3V2.70002C0.300049 2.20502 0.476299 1.78128 0.828799 1.42878C1.1813 1.07628 1.60505 0.900024 2.10005 0.900024H9.15005C9.38338 0.900024 9.61255 0.941691 9.83755 1.02502C10.0625 1.10836 10.2584 1.24169 10.425 1.42502L14.175 5.17502C14.3584 5.34169 14.4917 5.53752 14.575 5.76252C14.6584 5.98752 14.7 6.21669 14.7 6.45002V18.3C14.7 18.795 14.5237 19.2188 14.171 19.5713C13.8184 19.9238 13.3944 20.1 12.899 20.1H2.09305ZM8.70005 6.00002C8.70005 6.25502 8.7863 6.46878 8.9588 6.64127C9.1313 6.81378 9.34505 6.90002 9.60005 6.90002H12.9L8.70005 2.70002V6.00002Z"
                                    fill="#1E5AA8" />
                            </svg>
                        </button>

                        <!-- Add Button -->
                        <button
                            *ngIf="(isSuperuser && !(router?.url?.includes('admin/data-change-logger') || router?.url?.includes('docstatus-management') || router?.url?.includes('user-activity') || router?.url?.includes('search/document-grid') || router?.url?.includes('billing-details') || router?.url?.includes('bre'))) || buttonConfig?.showAddButton"
                            (click)="onClickAddUpdateModal()" pButton icon="pi pi-plus" tooltipPosition="top"
                            pTooltip="Add" class="grid-buttons">
                        </button>

                        <!-- Expand button -->
                        <button pButton (click)="toggleTableExpansion()" size="small"
                            [icon]="isTableExpanded?'pi pi-window-minimize':'pi pi-window-maximize'"
                            tooltipPosition="top" [pTooltip]="isTableExpanded?'Minimize':'Maximize'"
                            class="grid-buttons">
                        </button>

                    </div>
                    <!-- <button *ngIf="(router?.url?.includes('shipment'))" (click)="onClickUploadExcel()" pButton
                        icon="fas fa-upload mr-2"
                        style="cursor: pointer; color: #1b5786 !important; background-color: #fff;">
                        Upload Excel
                    </button> -->
                    <!-- <button *ngIf="router?.url?.includes('search/document-grid')" (click)="onClickUploadInvoice()" pButton
                    pTooltip="Upload Document"  tooltipPosition="top" class="mr-2"
                        style="cursor: pointer; color: #1b5786 !important; background-color: #fff;">
                        <img src="../../../../../assets/layout/images/upload_excel.svg">
                    </button> -->

                    <!-- <span *ngIf="router?.url?.includes('billing-details')"
                        style="display: flex; justify-content: flex-end; flex-grow: 1;">
                        <button *ngIf="!selectedClientId"
                            (click)="getBillingExport(document?.['client_id'])"
                            style="cursor: pointer;color: #1b5786 !important;background-color: #fff;" class="mr-2" pButton
                            pButton icon="fas fa-file-export" pTooltip="EXPORT"></button>
                        <button *ngIf="selectedClientId"
                            (click)="getClientBillingExport(document?.['client_id'])"
                            style="cursor: pointer;color: #1b5786 !important;background-color: #fff;" class="mr-2" pButton
                            pButton icon="fas fa-file-export" pTooltip="EXPORT"></button>
                    </span> -->

                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th class="action" [ngStyle]="{'width': '30px'}" pFrozenColumn
                    *ngIf="name != 'billing' && !router?.url?.includes('bre')">Actions<br>

                </th>
                <!-- if bre introduced then will see -->
                <!-- pFrozenColumn *ngIf="(name != 'billing' && !router?.url?.includes('bre')) || !(router?.url?.includes('search/document-grid') && selectedCard.id == 5)">Actions|{{name != 'billing'}}-{{router?.url?.includes('bre')}}-{{!(router?.url?.includes('search/document-grid') && selectedCard.id==5)}}-{{selectedCard.id==5}}<br>     -->
                <th [ngStyle]="{
                'white-space': 'nowrap',
                'text-overflow': 'ellipsis',
                'overflow': 'hidden',
                'width': col?.width ? col.width + 'px' : '200px'}
                " *ngFor="let col of user_grid_schema" [pSortableColumn]="col?.key"
                    [pSortableColumnDisabled]="!col.is_sortable">
                    <div [ngSwitch]="col?.label">
                        <span *ngSwitchDefault>{{col?.label}}
                            <p-sortIcon *ngIf="col?.is_sortable" field="{{col?.key}}"></p-sortIcon>
                        </span>
                    </div>
                </th>
            </tr>
            <!-- <tr class="filterRow" *ngIf="(isSuperuser && !buttonConfig?.hideFilterButton) || (selectedClientId &&  !buttonConfig?.hideFilterButton)"> -->
            <tr class="filterRow" *ngIf="handleFilter && router?.url?.includes('search/document-grid')">
                <th style="max-width: 115px; height: 56px !important;" class="flex align-items-center" pFrozenColumn>
                    <button (click)="onClickReset()" pButton class="text-button link-button p-0 px-1 m-0"
                        pTooltip="RESET">RESET</button>
                    <!-- <button (click)="onClickFilter()" [disabled]="!hasFilterValues()" pButton icon="pi pi-filter"
                        pTooltip="APPLY" class="text-button link-button p-0 px-1 m-0"></button> -->
                </th>

                <th [ngStyle]="{'min-width': col?.width + 'px'}" *ngFor="let col of user_grid_schema">
                    <div [ngSwitch]="col?.filter_type" class="w-12" *ngIf="col?.is_filterable">
                        <span *ngSwitchCase="'dropdown'">
                            <p-columnFilter [field]="col?.key" matchMode="in" [showMenu]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <span class="flex justify-content-start align-items-center">
                                        <p-dropdown #dropdown [options]="col?.filter_options" optionLabel="name"
                                            optionValue="id"
                                            [ngStyle]="{ 'max-width': 'fit-content' + 'px','min-width': col?.width + 'px'}"
                                            [autoDisplayFirst]="false" [resetFilterOnHide]="true"
                                            [(ngModel)]="filterModel[col?.key]" [showClear]="true" appendTo="body">
                                            <ng-template let-itm pTemplate="selectedItem">
                                                <div style="display: grid; grid-template-columns: auto 20% 20%;">
                                                    <span style="text-align: left;">{{itm.name}}</span>
                                                </div>
                                            </ng-template>
                                        </p-dropdown>
                                    </span>
                                </ng-template>
                            </p-columnFilter>
                        </span>
                        <span *ngSwitchCase="'multiselect'">
                            <p-columnFilter [field]="col?.key" matchMode="in" [showMenu]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <span class="flex justify-content-start align-items-center">
                                        <p-multiSelect #multiselect [options]="col?.filter_options" optionLabel="name"
                                            optionValue="id" (onClear)="onClickClearOptionsFilter(multiselect,col?.key)"
                                            [ngStyle]="{ 'max-width': col?.width + 'px', 'min-width': '250px','color':'#515C66' }"
                                            [autoDisplayFirst]="false" [resetFilterOnHide]="true"
                                            [(ngModel)]="filterModel[col?.key]" [showClear]="true" appendTo="body"
                                            [maxSelectedLabels]="0" [selectedItemsLabel]="'{0} items selected'">
                                            <ng-template pTemplate="footer">
                                                <span class="flex justify-content-center p-2">
                                                    <button pButton label="APPLY"
                                                        class="sidebar-button cozmos-primary-button"
                                                        (click)="onClickApplyOptionsFilter(multiselect)"></button>
                                                    <button pButton label="CLEAR"
                                                        class="sidebar-button cozmos-secondary-button ml-2"
                                                        (click)="onClickClearOptionsFilter(multiselect,col?.key)"></button>
                                                </span>
                                            </ng-template>
                                        </p-multiSelect>
                                    </span>
                                </ng-template>
                            </p-columnFilter>
                        </span>
                        <span *ngSwitchCase="'radiobutton'">
                            <p-columnFilter [field]="col?.key" matchMode="in" [showMenu]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <span class="flex justify-content-start align-items-center">
                                        <div *ngFor="let category of col?.filter_options" class="w-12">
                                            <p-radioButton [inputId]="category.value" name="category"
                                                [value]="category?.value"
                                                [(ngModel)]="filterModel[col?.key]"></p-radioButton>
                                            <label [for]="category.value">{{category.name}}</label>
                                        </div>

                                    </span>
                                </ng-template>
                            </p-columnFilter>
                        </span>
                        <span *ngSwitchCase="'calendar'">
                            <p-columnFilter [field]="col?.key" matchMode="in" [showMenu]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <span class="flex justify-content-start align-items-center">
                                        <p-calendar appendTo="body" tooltipPosition="left"
                                            [(ngModel)]="filterModel[col?.key]" [hideOnDateTimeSelect]="true"
                                            selectionMode="range" [showIcon]="true" showClear="true"
                                            (ngModelChange)="onDateSelectGrid($event, col?.key)" showButtonBar="true"
                                            [readonlyInput]="true">
                                        </p-calendar>
                                    </span>
                                </ng-template>
                            </p-columnFilter>
                        </span>
                        <span *ngSwitchDefault [pTooltip]="document?.[col.key]">
                            <p-columnFilter [field]="col?.key" matchMode="in" [showMenu]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <span class="flex justify-content-start align-items-center">
                                        <input pInputText type="text" class="w-12"
                                            [(ngModel)]="filterModel[col?.key.endsWith('_by') ? col.key.replace('_by', '_by_name') : col.key]"
                                            (keyup)="debounceFilter()">
                                    </span>
                                </ng-template>
                            </p-columnFilter></span>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-document>
            <tr>
                <!-- name != 'billing' && !router?.url?.includes('bre') removing this from the td condition -->
                <td style="height: 41px !important;" [ngStyle]="{'min-width': col?.width + 'px'}"
                    class="flex justify-content-center" *ngIf="name != 'billing' && !router?.url?.includes('bre')"
                    pFrozenColumn [ngStyle]="{
                        'display': 'flex','justify-content':'center'}">

                    <ng-container
                        *ngIf="(hideUpdateDeleteButton &&  !router?.url?.includes('billing-details')) || buttonConfig?.showEditButton">
                        <button pButton type="button" class="p-button-text action-button" pTooltip="Edit"
                            id="{{'doc-details'+document?.id}}" aria-label="doc-details" tooltipPosition="top"
                            icon="fas fa-edit" (click)="onClickEdit(document, document?.id)">
                        </button>
                    </ng-container>

                    <ng-container
                        *ngIf="(hideUpdateDeleteButton && !router?.url?.includes('user-management') && !router?.url?.includes('document-type') && !router?.url?.includes('role-management') && !router?.url?.includes('docstatus-management') && !router?.url?.includes('billing-details') && !router?.url?.includes('vendor-management') && !router?.url?.includes('customer-management') && !router?.url?.includes('customer-sbu-management'))  || buttonConfig?.showDeleteButton">
                        <button pButton type="button" class="p-button-text action-button"
                            (click)="onClickDelete(document?.id)" pTooltip="Delete" id="{{'doc-details'+document?.id}}"
                            aria-label="doc-details" tooltipPosition="top" icon="fas fa-trash">
                        </button>
                    </ng-container>

                    

                    <ng-container
                        *ngIf="(isSuperuser && router?.url?.includes('search/document-grid')) || (buttonConfig?.showDocumentButton && router?.url?.includes('/search/document-grid'))">
                        <button (click)="onClickViewPDF(document)" pButton type="button"
                            class="p-button-text action-button"
                            [pTooltip]="![25, 45, 50, 70, 95].includes(document?.current_status_code)?document.re_assigned_to_id != null ? (userDetails.id === document.re_assigned_to_id ? 'Edit' : 'View') : document.assigned_to_id != null ? (userDetails.id === document.assigned_to_id ? 'Edit' : 'View') : userDetails.id == document.created_by_id && (selectedCard.id == 90)? 'Edit' : 'View': 'View'"
                            id="{{'doc-details'+document?.id}}" aria-label="doc-details" tooltipPosition="top"
                            [icon]="![25, 45, 50, 70, 95].includes(document?.current_status_code)?document.re_assigned_to_id != null ? (userDetails.id === document.re_assigned_to_id ? 'fas fa-edit' : 'fas fa-eye') : document.assigned_to_id != null ? (userDetails.id === document.assigned_to_id ? 'fas fa-edit' : 'fas fa-eye') : userDetails.id == document.created_by_id && (selectedCard.id == 90)? 'fas fa-edit' : 'fas fa-eye':'fas fa-eye'">
                            <!-- {{ document.re_assigned_to_id }}{{ document.assigned_to_id }} {{document.created_by_id}} {{selectedCard.id}} -->
                            <!-- {{[25, 50, 70, ].includes(document?.current_status)}} {{document?.current_status_code}} -->
                        </button>
                    </ng-container>
                    <ng-container
                        *ngIf="router?.url?.includes('user/super-admin/client') && document?.client_feature == null && document?.is_active">
                        <button (click)="onClickAddSubscription(document)" pButton type="button"
                            class="p-button-text action-button" pTooltip="Add Subscription"
                            id="{{'doc-details'+document?.id}}" aria-label="doc-details" tooltipPosition="top"
                            icon="fa fa-plus-circle">
                        </button>
                    </ng-container>

                    <!-- <ng-container *ngIf="router?.url?.includes('user/search/document-grid')">
                        <button (click)="onClickDownloadUploadedFile(document?.id)" pButton type="button"
                            class="p-button-text action-button" pTooltip="Download" id="{{'doc-details'+document?.id}}"
                            aria-label="doc-details" tooltipPosition="top" icon="far fa-file-download">
                        </button>
                    </ng-container> -->

                    <ng-container
                        *ngIf="!(document?.client_feature === null) && (router?.url?.includes('user/super-admin/client')  && (document?.is_active))">
                        <button (click)="onClickViewSubscription(document)" pButton type="button"
                            class="p-button-text action-button" pTooltip="View Subscription" aria-label="doc-details"
                            tooltipPosition="top" icon="fas fa-eye">
                        </button>
                    </ng-container>

                    <ng-container
                        *ngIf="((isSuperuser && router?.url?.includes('search/document-grid')) || buttonConfig?.showVersioning) && document?.version_number > 1">
                        <button (click)="oClickViewVersions(document)" pButton type="button"
                            class="p-button-text action-button" pTooltip="View Versions"
                            id="{{'doc-details'+document?.id}}" aria-label="doc-details" tooltipPosition="top"
                            icon="far fa-layer-group">
                        </button>
                    </ng-container>

                    <ng-container
                        *ngIf="(isSuperuser && router?.url?.includes('search/document-grid') && selectedCard.id == 30) || (userDetails.user_type != 15 && buttonConfig?.showDocumentButton && router?.url?.includes('/search/document-grid') && (selectedCard.id == 30))">
                        <button pButton (click)="onClickAssign($event, op, document, document?.id)" type="button"
                            class="p-button-text action-button" pTooltip="Assign" [id]="'doc-details'+document?.id"
                            aria-label="doc-details" tooltipPosition="top" icon="fas fa-user-plus">
                            <!-- {{userDetails.role}} -->
                        </button>
                        <!-- assigning overlay pannel -->
                        <p-overlayPanel #op (onHide)="onAssignOverlayPanelHide()">
                            <span class="font-medium text-900 block mb-2">Assign to BNS Users</span>
                            <input pInputText type="text" placeholder="Search..." [(ngModel)]="filterText"
                                (input)="onFilterChange($event)" style="width: 100%; margin-bottom: 0.5rem;" />
                            <div *ngIf="!isSearching else searching">
                                <div style="max-height: 200px; overflow-y: auto;">
                                    <ul *ngIf="filteredUsers.length != 0 else elseBlock"
                                        style="list-style: none; margin: 0; padding: 0;">
                                        <li *ngFor="let user of filteredUsers" (click)="onSelectBnsOperator(user)"
                                            style="
                                                padding: 0.5rem;
                                                cursor: pointer;
                                                border-bottom: 1px solid #ddd;
                                                display: flex;
                                            ">
                                            <span style="flex-grow:1;">{{ user.first_name }} {{user.last_name}}</span>
                                            <i *ngIf="user.id == (selectedDocument != null ? selectedDocument?.reassign_to_id != null? selectedDocument?.reassign_to_id:selectedDocument?.assign_to_id != null?selectedDocument?.assign_to_id: -1 :-1)"
                                                class="pi pi-check text-success"></i>
                                        </li>
                                    </ul>
                                    <ng-template #elseBlock>
                                        <p class="text-center p-3 text-sm">No users found</p>
                                    </ng-template>
                                </div>
                            </div>
                            <ng-template #searching>
                                <p-progressBar *ngIf="isSearching" mode="indeterminate"
                                    [style]="{height:'2px', margin:'10px 0px'}" />
                            </ng-template>
                        </p-overlayPanel>
                    </ng-container>

                    <ng-container
                        *ngIf="(isSuperuser && router?.url?.includes('search/document-grid')) || (buttonConfig?.showDocumentButton && router?.url?.includes('/search/document-grid'))">
                        <button *ngIf="![25, 45, 50, 70, 95].includes(document?.current_status_code)?document.re_assigned_to_id != null ? (userDetails.id === document.re_assigned_to_id ? userDetails.role == 'Vendor' ? false: true : false) : document.assigned_to_id != null ? (userDetails.id === document.assigned_to_id ? true : false) : userDetails.id == document.created_by_id && (selectedCard.id == 90)? true : false: false" (click)="onClickCancelInvoice(document)" pButton type="button"
                            class="p-button-text action-button"
                            pTooltip="Cancel Invoice"
                            id="{{'doc-details'+document?.id}}" aria-label="doc-details" tooltipPosition="top"
                            (click)="onClickCancel(document)"
                            icon="fa fa-ban">
                        </button>
                    </ng-container>

                    <ng-container
                        *ngIf="document?.type=='MultiSelect' || document?.type=='Radio Button' || document?.type=='Dropdown'">
                        <button (click)="onClickViewConfig(document)" pButton type="button"
                            class="p-button-text action-button" pTooltip="Config Field Options"
                            id="{{'doc-details'+document?.id}}" aria-label="doc-details" tooltipPosition="top"
                            icon="fas fa-cog">
                        </button>
                    </ng-container>
                    <!-- to show the locked document -->
                    <img *ngIf="document?.is_locked && document?.modified_by != 0 && false" class="editIcon"
                        pTooltip="This Document is currently locked and being edited."
                        src="../../../../../assets/layout/images/document-lock.gif" alt="editing">
                    <!-- <button *ngIf="document?.is_locked" class="p-button-text action-button" pButton type="button"
                        pTooltip="This Document is currently locked."
                        icon="pi pi-lock"></button> -->
                </td>

                <td style="height: 38px !important;" [ngStyle]="{'min-width': col?.width + 'px', 'max-width': '300px'}"
                    *ngFor="let col of user_grid_schema">
                    <div [ngSwitch]="col?.key">
                        <div style="
                                white-space: wrap;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                overflow: hidden;" [ngClass]="getStatusClass(col, document)" *ngSwitchDefault
                            [pTooltip]="document?.[col.key]">
                            <span *ngIf="!(col?.label === 'Surcharges' && router?.url?.includes('rateCard'))" [ngStyle]="{
                                    'width': col?.width ? col.width + 'px' : '300px',
                                    'padding-right': '3px', 'color': col?.label === 'Transaction ID' ? '#002B45' : '',
                                    'font-weight': col?.label === 'Transaction ID' ? 'bolder' : ''
                                }" tooltipPosition="left">
                                {{ document?.[col.key] || '...'}}
                            </span>
                        </div>

                        <span *ngSwitchCase="'status'" class="status-cell">
                            <span *ngIf="document['status']==true">
                                <p class="status-badge active">Active</p>
                            </span>
                            <span *ngIf="document['status']==false">
                                <p class="status-badge inactive">Inactive</p>
                            </span>
                        </span>
                        <span *ngSwitchCase="'is_active'" class="status-cell">
                            <span *ngIf="document['is_active']==true">
                                <p class="status-badge active">Active</p>
                            </span>
                            <span *ngIf="document['is_active']==false">
                                <p class="status-badge inactive">Inactive</p>
                            </span>
                        </span>
                        <span *ngSwitchCase="'user_type'">
                            <span *ngIf="document['user_type']==10">
                                <p class="status-badge internal">Internal User</p>
                            </span>
                            <span *ngIf="document['user_type']==15">
                                <p class="status-badge external">External User</p>
                            </span>
                            <span *ngIf="document['user_type']==5">
                                <p class="status-badge cozentus">Cozentus User</p>
                            </span>
                        </span>
                        <span *ngSwitchCase="'company_type'">
                            <span *ngIf="document['company_type']==5">
                                <p>CUSTOMER</p>
                            </span>
                            <span *ngIf="document['company_type']==10">
                                <p>VENDOR</p>
                            </span>
                        </span>
                        <span *ngSwitchCase="'db_assigned'">
                            <span *ngIf="document.is_active === true">
                                <p-inputSwitch [(ngModel)]="document.db_assigned"
                                    [disabled]="document.db_assigned === true"
                                    (onChange)="onAssignDB($event,document)" />
                            </span>
                        </span>
                        <!-- <span *ngSwitchCase="'is_superuser'">
                            <span *ngIf="isSuperuser">
                            <p-inputSwitch [(ngModel)]="document.is_superuser" [disabled]="document.is_superuser === true"
                                (onChange)="onChangeSuperUser($event,document)" />
                            </span>
                        </span> -->
                        <span *ngSwitchCase="'item_details'">
                            <button (click)="onClickGoToItemDetailsPage(document)" pButton type="button"
                                class="p-button-text action-button" pTooltip="Go To Item Details"
                                aria-label="doc-details" tooltipPosition="top" icon="pi pi-book"></button>
                        </span>
                        <span *ngSwitchCase="'rules'">
                            <button (click)="onClickGoToRulesPage(document)" pButton type="button"
                                class="p-button-text action-button" pTooltip="Rules Setup" aria-label="doc-details"
                                tooltipPosition="top" icon="pi pi-book"></button>
                        </span>
                        <span *ngSwitchCase="'connectivity_details'">
                            <button pButton (click)="onClickAddConnectivitySetup(document)"
                                *ngIf="!document?.connectivity_details_object" type="button"
                                class="p-button-text action-button" pTooltip="Add" id="{{'doc-details'+document?.id}}"
                                aria-label="doc-details" tooltipPosition="top" icon="pi pi-plus"></button>
                            <button pButton type="button" *ngIf="document?.connectivity_details_object"
                                (click)="onClickViewConnectivitySetup(document,document?.connection_detail_id)"
                                class="p-button-text action-button" pTooltip="View" id="{{'doc-details'+document?.id}}"
                                aria-label="doc-details" tooltipPosition="top" icon="fas fa-eye"></button>
                            <button pButton type="button" *ngIf="document?.connectivity_details_object"
                                (click)="onClickEditConnectivitySetup(document,document?.connection_detail_id)"
                                class="p-button-text action-button" pTooltip="Edit" id="{{'doc-details'+document?.id}}"
                                aria-label="doc-details" tooltipPosition="top" icon="fas fa-edit"></button>
                            <button pButton type="button" *ngIf="document?.connectivity_details_object"
                                (click)="onClickDeleteConnectivitySetup(document?.connection_detail_id)"
                                class="p-button-text action-button" pTooltip="Delete"
                                id="{{'doc-details'+document?.id}}" aria-label="doc-details" tooltipPosition="top"
                                icon="fas fa-trash"></button>
                        </span>
                        <span *ngSwitchCase="'required'">
                            <span *ngIf="document['required']==1">
                                YES
                            </span>
                            <span *ngIf="document['required']==0">
                                NO
                            </span>
                        </span>
                        <span *ngSwitchCase="'is_editable'">
                            <span *ngIf="document['is_editable']==true">
                                YES
                            </span>
                            <span *ngIf="document['is_editable']==false">
                                NO
                            </span>
                        </span>
                        <span *ngSwitchCase="'version_flag'">
                            <span *ngIf="document['version_flag']==true">
                                YES
                            </span>
                            <span *ngIf="document['version_flag']==false">
                                NO
                            </span>
                        </span>
                        <span *ngSwitchCase="'controller'">
                            <button pButton type="button" class="p-button-text action-button h-1rem"
                                pTooltip="View Email Template Controller" tooltipPosition="top"
                                icon="fas fa-envelope-open-text"
                                (click)="onClickNavigateToController(document)"></button>
                        </span>
                        <!-- <span [ngStyle]="{
                            'white-space': 'nowrap',
                            'text-overflow': 'ellipsis',
                            'overflow': 'hidden',
                            'width': col?.width ? col.width + 'px' : '180px',
                            'display': 'block',
                            'padding-right': '3px'
                        }" *ngSwitchCase="'role_name'">
                            <span *ngIf="router?.url?.includes('user-management')"
                                [pTooltip]="getRoleName(document)">{{getRoleName(document)}}</span>
                            <span *ngIf="!router?.url?.includes('user-management')"
                                [pTooltip]="document?.role_name">{{document?.role_name}}</span>
                        </span> -->
                        <span [ngStyle]="{
                            'white-space': 'nowrap',
                            'text-overflow': 'ellipsis',
                            'overflow': 'hidden',
                            'width': col?.width ? col.width + 'px' : '180px',
                            'display': 'block',
                            'padding-right': '3px'
                        }" *ngSwitchCase="'application_id'">
                            <span [pTooltip]="getApplicationName(document)">{{getApplicationName(document)}}</span>
                        </span>
                        <span [ngStyle]="{
                            'white-space': 'nowrap',
                            'text-overflow': 'ellipsis',
                            'overflow': 'hidden',
                            'width': col?.width ? col.width + 'px' : '180px',
                            'display': 'block',
                            'padding-right': '3px'
                        }" *ngSwitchCase="'long_desc'">
                            <span [pTooltip]="document?.description">{{document?.description}}</span>
                        </span>
                        <!-- Add Surcharges -->
                        <span *ngIf="(col?.label === 'Surcharges' && router?.url?.includes('rateCard'))">
                            <button pButton type="button" class="p-button-text py-0" aria-label="doc-details"
                                pTooltip="Add" tooltipPosition="top" icon="fas fa-plus"
                                (click)="handleAddClick(document?.id)">
                            </button>
                        </span>
                        <span *ngSwitchCase="'data_access'">
                            <a *ngIf="!document?.is_superuser" class="cursor-pointer p-button-rounded p-button-success"
                                pTooltip="View Role & Access" (click)="onClickViewApplicationPrivileges(document)"
                                tooltipPosition="top"><i class="fas fa-user-tag"></i></a>
                            <a *ngIf="document?.is_superuser" class="cursor-pointer p-button-rounded p-button-success"
                                (click)="onClickViewSuperUserApplicationPrivileges()"
                                pTooltip=" Super Admin has full access to all applications, including associated document types and business units."
                                tooltipPosition="top"><i class="fas fa-user-tag"></i></a>
                        </span>
                        <span *ngSwitchCase="'token'">
                            <a class="cursor-pointer p-button-rounded p-button-success" pTooltip="Generate Token"
                                (click)="onClickGenerateToken(document)" tooltipPosition="top"><i
                                    class="fad fa-cogs"></i></a>
                        </span>
                        <span *ngSwitchCase="'logo'">
                            <div class="app_logo">
                                <img [src]="'data:image/png;base64,'+document?.logo">
                            </div>
                        </span>
                        <span *ngSwitchCase="'business_allocation'">
                            <a class="cursor-pointer" pTooltip="View Business Allocation"
                                (click)="onClickViewBusinessAllocation(document)" tooltipPosition="top"><i
                                    class="fas fa-briefcase"></i></a>
                        </span>
                        <span *ngSwitchCase="'names'">
                            <a class="cursor-pointer p-button-rounded p-button-success" pTooltip="View Role Privileges"
                                (click)="onClickViewPrivileges(document)" tooltipPosition="top">View Privilege</a>
                        </span>
                        <span *ngSwitchCase="'sbu_names'">
                            <a class="cursor-pointer p-button-rounded p-button-info" pTooltip="View SBU List"
                                tooltipPosition="top" (click)="onClickViewSbuList(document)">
                                View Sbu List
                            </a>
                        </span>
                        <span *ngSwitchCase="'vendors'">
                            <a class="cursor-pointer p-button-rounded p-button-info" pTooltip="View Vendor List"
                                tooltipPosition="top" (click)="onClickViewVendor(document)">
                                View Vendor List
                            </a>
                        </span>
                        <span *ngSwitchCase="'customers'">
                            <a class="cursor-pointer p-button-rounded p-button-info" pTooltip="View Customer List"
                                tooltipPosition="top" (click)="onClickViewCustomer(document)">
                                View Customer List
                            </a>
                        </span>
                        <span *ngSwitchCase="'payload'" class="cursor-pointer">
                            <a class="p-button-rounded p-button-success" pTooltip="Payload" tooltipPosition="top"
                                (click)="onClickPayloadIcon(document?.payload)"><i class="fas fa-file"></i></a>
                        </span>
                        <span *ngSwitchCase="'file_content'" class="cursor-pointer">
                            <a *ngIf="document.file_content"
                                (click)="onClickDownloadAttachment(document.file_content,document?.short_desc)"
                                pTooltip="Download Attachment" tooltipPosition="top">
                                <i class="far fa-file-download"></i>
                            </a> </span>
                        <span *ngSwitchCase="'audit_error_sub_status'" class="cursor-pointer"
                            [pTooltip]="(document.reassigned_to_id != null || document.assigned_to_id != null ? ('Assigned & ' + document.audit_error_sub_status) : document.audit_error_sub_status) | titlecase">
                            {{ (document.audit_error_sub_status != null ? document.reassigned_to_id != null ||
                            document.assigned_to_id != null ? ('Assigned & ' + document.audit_error_sub_status) :
                            document.audit_error_sub_status: "") | titlecase }}
                        </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="60" *ngIf="!router?.url?.includes('billing-details')">No Data found.</td>
                <td colspan="60" *ngIf="router?.url?.includes('billing-details')">No billing records found for the
                    selected
                    filters.</td>
            </tr>
        </ng-template>
    </p-table>
    <p-paginator #paginator (onPageChange)="paginate($event)" [rows]="page_size" [showCurrentPageReport]="true"
        class="pageRow" [templateRight]="templateRight"
        currentPageReportTemplate="Showing  {first} to {last} of {{total_records}} Records {{date_range}} "
        [totalRecords]="total_records" [rowsPerPageOptions]="page_size_list">
    </p-paginator>
</div>
<!-- <p-speedDial tooltip="Config" [model]="items" [mask]="true" direction="up" [transitionDelay]="80" showIcon="pi pi-bars" hideIcon="pi pi-times" buttonClassName="p-button-outlined"></p-speedDial> -->
<ng-template #templateRight>
    <span class="flex w-full paginator-goto">
        <input pInputText [(ngModel)]="jumpToPageNo" (keyup.enter)="jumpToPage($event)" type="number"
            placeholder="Go To Page"
            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"></span>
</ng-template>

<p-toast position="top-center" [preventOpenDuplicates]="true"></p-toast>

<p-dialog [(visible)]="showColumnSettingsModal" header="Column Settings" styleClass="w-5" [closable]="true"
    [modal]="true" [draggable]="false" [resizable]="false" (onHide)="onHideColumnSettings()">
    <p-table [columns]="user_schema" [value]="user_schema" [reorderableColumns]="true" [resizableColumns]="true"
        [scrollable]="true" scrollHeight="395px" scrollDirection="vertical">
        <ng-template pTemplate="caption">
            <div class="table-header" class="flex justify-content-end">
                <button pButton type="button" label="RESET" class="mr-2 cozmos-secondary-button"
                    (click)="onClickResetColumnSettings()"></button>
                <button pButton type="button" label="SAVE" class="mr-2 cozmos-primary-button"
                    (click)="onClickSaveColumnSettings()"></button>
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr class="block">
                <th class="reorder-col bg-white pb-2 pt-2" *ngFor="let col of columns; let i = index;"
                    pReorderableColumn [pReorderableColumnDisabled]="col?.is_disabled" pResizableColumn>
                    <span class="mr-3" style="width:15px;">{{i+1}}.</span>
                    <span *ngIf="!col?.is_disabled" class="mr-4">
                        <p-checkbox [binary]="true" inputId="binary" [(ngModel)]="col.is_selected"></p-checkbox>
                    </span>
                    <span *ngIf="!col.disabled" class="pi pi-bars mr-3"></span>
                    <span class="ml-3">{{col?.label}}</span>
                </th>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>

<p-dialog styleClass="w-7" (onHide)="onDialogClose()" [draggable]="false" [resizable]="false" header="Upload Invoice"
    [modal]="true" [(visible)]="displayDocuments">
    <form [formGroup]="uploadForm">
        <div class="grid">
            <div class="col-4">
                <label class="fieldLabel">Invoice Type<span class="requiredField">*</span></label>
                <p-dropdown styleClass="w-12" appendTo="body" [options]="documentTypeList" optionLabel="name"
                    optionValue="id" [filter]="true" placeholder="Select Invoice Type" formControlName="document_type">
                    <ng-template let-itm pTemplate="selectedItem">
                        <div style="display: grid; grid-template-columns: auto 20% 20%;">
                            <span style="text-align: left">{{itm.name}}</span>
                        </div>
                    </ng-template>
                </p-dropdown>
                <small *ngIf="uploadForm.get('document_type').touched && uploadForm.get('document_type')?.invalid"
                    class="p-error">Invoice Type is a required field.</small>
            </div>
            <div class="col-4">
                <label class="fieldLabel">File Type<span class="requiredField">*</span></label>
                <p-dropdown appendTo="body" styleClass="w-12" [options]="fileTypelist" [showClear]="true"
                    [filter]="true" placeholder="Select File Type" optionLabel="name" optionValue="id"
                    formControlName="file_type">
                    <ng-template let-itm pTemplate="selectedItem">
                        <div>
                            <span>{{ itm?.name }}</span>
                        </div>
                    </ng-template>
                </p-dropdown>
                <small *ngIf="uploadForm.get('file_type').touched && uploadForm.get('file_type')?.invalid"
                    class="p-error">File Type is a required field.</small>
            </div>
            <div class="col-12 p-2">
                <p-fileUpload #fileUpload [disabled]="!this.uploadForm.valid" chooseLabel="" uploadLabel=""
                    cancelLabel="" (onClear)="clearFile()" customUpload="true" [accept]="'.pdf'"
                    (uploadHandler)="onUploading($event,fileUpload)" (onRemove)="handleFileRemove($event,fileUpload)"
                    [multiple]="false">
                </p-fileUpload>
            </div>
        </div>
    </form>
</p-dialog>

<p-dialog styleClass="w-7" (onHide)="onDialogClose()" [draggable]="false" [resizable]="false" header="Upload Excel"
    [modal]="true" [(visible)]="displayUploadExcel">
    <ng-template pTemplate="body">
        <div class="col-12" style="display: flex; justify-content: center; align-items: center;">
            <div style="
                    background: #f4f6fa;
                    border: 1px solid #ccc;
                    border-radius: 8px;
                    padding: 10px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    max-width: 90rem;
                    text-align: center;
                    position: relative;">
                <!-- Image Preview -->
                <img [src]="'assets/layout/images/shipping.png'" alt="Excel Preview"
                    style="width: 100%; max-height: 200px; object-fit: contain; border: 1px solid #ddd; border-radius: 4px;" />

                <!-- File name -->
                <div style="margin-top: 8px; font-size: 14px; color: #333;">
                    shipment_sample.xlsx
                </div>

                <!-- Download icon button in place of 3 dots -->
                <button *ngIf="router?.url?.includes('shipment')" (click)="downloadExcel()" pButton
                    icon="pi pi-download" style="
                        position: absolute;
                        right: 10px;
                        bottom: 10px;
                        background: none;
                        border: none;
                        cursor: pointer;
                        color: #1b5786;
                        font-size: 18px;
                    " title="Download Excel">
                </button>
            </div>
        </div>
        <div class="col-12">
            <label for="fileUpload" class="input-label">Upload File</label>
            <p-fileUpload #fileUpload chooseLabel="" uploadLabel="" cancelLabel="" (onClear)="clearFile()"
                customUpload="true" (uploadHandler)=" onExcelUploading($event,fileUpload)"
                (onRemove)="handleFileRemove($event,fileUpload)" multiple="multiple">
            </p-fileUpload>
            <div *ngIf="errUpload" class="error-message">
                <small>Upload the File</small>
            </div>

        </div>
        <div *ngIf="getErrorRows().length" class="error-list mt-4 p-3 border-round surface-100">
            <div *ngFor="let row of getErrorRows()" class="mb-3 border-left-3 border-red-500 pl-3">
                <h6 class="text-lg font-semibold text-red-600 mb-2">{{ row }}</h6>
                <ul class="list-disc ml-4 text-sm text-red-700">
                    <li style="list-style: none; font-size: 12px;color: red;" *ngFor="let error of error_message[row]"
                        class="mb-1">{{ error }}</li>
                </ul>
            </div>
        </div>
    </ng-template>

</p-dialog>


<input #fileInput type="file" (change)="onClickUploadExcelData($event)" style="display: none;" />

<!-- Assign Modal dialog starts here -->
<p-dialog header="Confirm Assignment" [(visible)]="showAssignConfirmModal" styleClass="w-4" [modal]="true"
    [closable]="true" [draggable]="false">
    <p>Are you sure you want to assign Invoice with Doucument ID <b>{{selectedDocument?.transaction_id}}</b> to
        <b>{{selectedBns?.first_name}} {{selectedBns?.last_name}}</b> ? </p>
    <div class="my-2" style="display: flex; justify-content: end;">
        <!-- <p-button class="m-1 cozmos-primary-button" label="Cancel"  (click)="showAssignModal = false" />
        <p-button class="m-1 cozmos-primary-button" label="Assign" (click)="showAssignModal = false" /> -->
        <button pButton pRipple type="button" label="Cancel" (click)="onCancelAssign()"
            class="cozmos-secondary-button mr-2"></button>
        <button pButton pRipple type="button" label="Assign" class="cozmos-primary-button"
            (click)="onApproveAssign()"></button>
    </div>
</p-dialog>
<!-- Assign Modal dialog ends here -->

<p-dialog [(visible)]="viewConfirmationModal" [closable]="true" [modal]="true" [resizable]="false" [draggable]="false" (onHide)="onHideCancel()"
    styleClass="w-5" header="Cancel Invoice">
    <p>Are you sure you want to cancel this invoice <b>({{documentToBeCancelled?.transaction_id}})</b>?</p>
    <form class="form" [formGroup]="AddCommentForm">
        <small><label>Remark</label> <span class="p-error">*</span></small>
        <div class="fluid my-2">
            <div class="p-field col-12 mb-0 p-0">
                <textarea autofocus id="message" #message class="w-full" placeholder="Please Enter your Reason here"
                    formControlName="comment" rows="5" pInputTextarea></textarea>
            </div>
            <div
                *ngIf="(AddCommentForm.get('comment')?.invalid && AddCommentForm.get('comment')?.touched) || AddCommentForm.get('comment')?.dirty">
                <small class="p-error" *ngIf="AddCommentForm.get('comment')?.errors?.required">Reason is
                    required.</small>
                <small class="p-error" *ngIf="AddCommentForm.get('comment')?.errors?.pattern">No Whitespace is
                    Allowed.</small>
                <small class="p-error" *ngIf="AddCommentForm.get('comment')?.errors?.minlength">Required to
                    enter minimum 3 characters.</small>
            </div>
        </div>
    </form>
    <hr />
    <div class="modalButtonAlign">
        <button pButton pRipple type="button" label="No" (click)="onHideCancel()"
            class="cozmos-secondary-button  mr-2"></button>
        <button pButton pRipple type="button" label="Yes" [disabled]="AddCommentForm.invalid" class="cozmos-primary-button" (click)="cancelDocumentAction()"></button>
    </div>
</p-dialog>